"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeScheduleError = exports.STRIPE_MAX_PHASES = void 0;
exports.toStripeSchedulePhases = toStripeSchedulePhases;
/** Stripe's hard cap on current + future phases (past ones do not count). */
exports.STRIPE_MAX_PHASES = 10;
class StripeScheduleError extends Error {
}
exports.StripeScheduleError = StripeScheduleError;
function toStripeSchedulePhases(phases, priceIdFor) {
    if (!phases || phases.length === 0) {
        throw new StripeScheduleError('a subscription schedule needs at least one phase');
    }
    /*
      A PHASE THAT BILLS NOTHING CANNOT BE SENT.
  
      `buildPricePhases` drops a line that costs nothing, so a "100% off for three
      months" promotion produces a phase with NO lines at all. Stripe rejects a
      phase with no items, and there is no honest way to invent one — so this is
      refused loudly here rather than at the Stripe call, where the error would
      name a phase index and nothing a human could act on.
  
      The fix is a product decision, not a mapping one: bill the promotion at one
      cent, or keep a $0 line explicitly, or start the subscription when the
      promotion ends. Whoever wrote the offer has to choose.
    */
    const empty = phases.findIndex((p) => !p.lines || p.lines.length === 0);
    if (empty >= 0) {
        throw new StripeScheduleError(`phase ${empty + 1} of ${phases.length} bills nothing at all — a fully discounted period cannot be `
            + 'expressed as a schedule phase, because Stripe requires at least one item per phase. Price the '
            + 'promotion above zero, or start the subscription when it ends.');
    }
    if (phases.length > exports.STRIPE_MAX_PHASES) {
        throw new StripeScheduleError(`this offer has ${phases.length} price phases and Stripe allows ${exports.STRIPE_MAX_PHASES}. `
            + 'Merge the steps that bill the same amount, or shorten the promotional ladder.');
    }
    return phases.map((phase, index) => {
        const isLast = index === phases.length - 1;
        const items = phase.lines.map((line) => ({
            price: priceIdFor(line),
            quantity: line.quantity,
        }));
        /*
          A DURATION, NOT DATES — and not `iterations` either, which the live API
          refuses on a phase (see `StripeSchedulePhase`). Our phases are already
          whole billing cycles: `startMonth` and the next phase's `startMonth` bound
          this one. The last phase is open-ended and carries no duration, running
          until the subscription is cancelled.
        */
        if (isLast)
            return { items };
        const next = phases[index + 1];
        const months = typeof phase.iterations === 'number'
            ? phase.iterations
            : next.startMonth - phase.startMonth;
        if (!Number.isInteger(months) || months < 1) {
            throw new StripeScheduleError(`phase ${index + 1} runs for ${months} billing cycles — a phase must run for at least one`);
        }
        return { items, duration: { interval: 'month', interval_count: months } };
    });
}
//# sourceMappingURL=stripeSchedule.js.map